import swal from "sweetalert";

export default function error_alert(title = "Erro", msg: string, callback = () => {}, options = {}) {
    if (swal && swal.getState && swal.close && swal.getState().isOpen) swal.close();

    swal(title, msg, { icon: "error", ...options }).then(e => callback());
}
